import React, {Fragment} from 'react';
import TextInput from '../form/TextInput';
import SelectorGrid from '../form/SelectorGrid/SelectorGrid';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import Button from "../form/Button";

class storeEditor extends React.Component {

    render() {
        const sortable = true;
        const filterable = true;
        return (
            <Fragment>
                <Box
                    theme="default"
                >
                    <SelectorGrid
                        componentConfig={this.props.componentConfig}
                        view="list"
                        columns={ {
                            "id": {width: 1, sortable, filterable},
                            "name": {header: 'Token', width: 2, sortable, filterable },
                        } }
                        pageSize={5}
                        orderBy={{field: this.props.componentConfig.idfield, direction: "DESC"}}
                        selection={this.props.selection}
                        onSelectionChange={ (selection) => this.props.loadForm(selection.value) }
                    />
                </Box>
                <Box
                    theme="default"
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty } color="primary" className="pull-right" onClick={ this.props.saveForm }>
                            Mentés
                        </Button>,
                        <Button key="1" color="default" className="pull-left" onClick={ this.props.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <form onSubmit={ this.props.handleSubmit }>
                        <div className="row form-row">
                            <div className="col-sm-4 col-sm-push-8">
                                <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                            </div>
                            <div className="col-sm-8 col-sm-pull-4">
                                <TextInput name="name" value={ this.props.values.name} label="Név" saveChanges={ this.props.setFieldValue }/>
                            </div>
                        </div>
                    </form>
                </Box>
            </Fragment>
        );
    }
}
export default createEditor({componentName: "store", WrappedComponent: storeEditor});
